import * as t from 'io-ts';
import { withFallback } from 'io-ts-types/lib/withFallback';
import { recordCodec as optionSetCodec } from '@/services/api/resources/optionSet/codec';

export const recordCodec = t.type({
  id: t.number,
  label: t.string,
  dataType: t.union([t.literal('text'), t.literal('dropdown')]),
  optionSetId: withFallback(t.union([t.number, t.null]), null),
  allowMulti: withFallback(t.boolean, false),
  optionSet: withFallback(t.union([optionSetCodec, t.null]), null),
});

export const listCodec = t.type({
  data: t.array(recordCodec),
});

export const formCodec = t.type({
  label: t.string,
  dataType: t.union([t.literal('text'), t.literal('dropdown')]),
  optionSetId: t.union([t.number, t.null]),
  allowMulti: t.boolean,
});
